
export const planNames = {
  month: "Monthly Plan",
  // `quarter` is keyed off `user.pricingPlan`, which activate-plan stores as the plan's
  // FREQUENCY. Without this entry `subscriptionDescription()` returns undefined for every
  // quarterly subscriber, and their plan renders blank on My Account, on the student
  // profile and in the admin's student detail view.
  quarter: "Quarterly Plan",
  year: "Yearly Plan",
  lifetime: "Lifetime Plan",
  free_lifetime: "Free Lifetime Plan",
  team_plan: "Team Member Plan"
};


export const teamPlanNames = {
  month: "Monthly Team Plan",
  year: "Yearly Team Plan"
};
